import { useState, useEffect } from "react";
import { FaPhone, FaBullseye, FaComments, FaFolderOpen } from "react-icons/fa";
import Tools from "../utils/Tools";

function IntentsTiles({ intents, filteredIntents, totalCalls }) {
  const [tiles, setTiles] = useState([]);

  const intentsToUse = filteredIntents ? filteredIntents : intents;

  const calculateTotalIntentCount = (intents) => {
    console.log("INTENTS", intents);
    let totalIntentCountCalc = 0;
    for (let i = 0; i < intents.length; i++) {
      const minorIntents = intents[i].minorIntents;
      for (let j = 0; j < minorIntents.length; j++) {
        totalIntentCountCalc += +minorIntents[j].count;
      }
    }
    return totalIntentCountCalc;
  };

  useEffect(() => {
    const minorIntentCount = intentsToUse.reduce(
      (sum, intent) => sum + (intent.minorIntents.length || 0),
      0
    );
    const uniqueCategoriesCount = new Set(
      intentsToUse.map((obj) => obj.category)
    ).size;

    // Update tiles based on allAgentInfo
    setTiles([
      {
        Icon: FaPhone,
        title: "Total Contacts",
        value: filteredIntents
          ?  Tools.formatNumber(calculateTotalIntentCount(intentsToUse) || 0)
          : Tools.formatNumber(totalCalls || 0),
      },
      {
        Icon: FaFolderOpen,
        title: "Categories",
        value: Tools.formatNumber(uniqueCategoriesCount || 0),
      },
      {
        Icon: FaBullseye,
        title: "Intents",
        value: Tools.formatNumber(intentsToUse.length || 0),
      },
      {
        Icon: FaComments,
        title: "Minor Intents",
        value: Tools.formatNumber(minorIntentCount || 0),
      },

      // Add more tiles as needed, using data from allAgentInfo
    ]);
  }, [intentsToUse, totalCalls, filteredIntents]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      {tiles.map((tile, index) => (
        <div
          key={index}
          className="usan-primary text-white p-4 rounded-xl shadow-lg flex items-center justify-between h-24 transition-all duration-300 hover:shadow-xl hover:scale-105"
        >
          <div className="flex flex-col items-center flex-grow">
            <div className="flex items-center">
              <p className="text-4xl font-bold">{tile.value}</p>
              {tile.trend && <span className="ml-2">{tile.trend}</span>}
            </div>
            <h3 className="text-sm font-semibold uppercase tracking-wide mt-1">
              {tile.title}
            </h3>
          </div>
          <tile.Icon className="text-4xl opacity-70 ml-4" />
        </div>
      ))}
    </div>
  );
}

export default IntentsTiles;
